import React from "react";
import { FaTimes } from "react-icons/fa";

const Rsidebar = ({ isOpen, setIsOpen, logs }) => {

  // console.log('aaa',logs)
  return (
    <div
      className={`fixed top-0 right-0 h-full w-64 bg-gray-800 text-white p-4 transition-transform duration-300 z-50 shadow-lg 
      ${isOpen ? "translate-x-0" : "translate-x-full"}`}
    >
      {/* Close Button */}
      <button
        onClick={() => setIsOpen(false)}
        className="absolute top-4 left-4 text-white text-xl"
      >
        <FaTimes />
      </button>

      {/* Sidebar Header */}
      <h2 className="text-xl font-bold text-center mt-4">Activity Logs</h2>


      {/* Logs List with Scrollbar */}
      <div className="mt-6 overflow-y-auto max-h-[calc(100vh-100px)] pr-2">
  {logs && logs.length > 0 ? (
    <ul className="flex flex-col space-y-4">
      {logs.map((log, index) => (
        <li key={index} className="flex flex-col space-y-2">
          {/* User Message */}
          <div className="flex justify-end">
            <div className="bg-blue-600 text-white p-3 rounded-lg max-w-[80%] break-words shadow-md">
              <div className="text-xs text-blue-200 mb-1">
                Query @ {new Date(log.created_at).toLocaleTimeString()}
              </div>
              <div className="whitespace-pre-wrap">{log.query}</div>
            </div>
          </div>

          {/* Assistant Response */}
          <div className="flex justify-start">
            <div className="bg-gray-700 text-white p-3 rounded-lg max-w-[80%] break-words shadow-md">
              <div className="text-xs text-gray-400 mb-1">Assistant</div>
              <div className="whitespace-pre-wrap">{log.answer}</div>
            </div>
          </div>
        </li>
      ))}
    </ul>
  ) : (
    <p className="text-gray-400 text-center">No logs available.</p>
  )}
</div>


    </div>
  );
};

export default Rsidebar;
